import * as yup from "yup";
import { alphabet_dash_regix } from "../utils/functions";

export const emptySignatory = {
    corpClientApplicationAccountOperationAuthSignId: null,
    fullName: "",
    identificationNo: "",
    jobTitle: "",
    nationalityId: "",
    sequenceId: "",
    signatureDocument: null
}
export const account_operation_schema = (data) => ({
    accountManagement: data?.accountManagement ?? null,
    accountManagementOther: data?.accountManagementOther ?? "",
    ClientApplicationId: data?.corpClientApplicationId ?? null,
    accountOperationAuthSigns: data?.accountOperationAuthSigns ?? [],
})


export const signatory_add_validation_schema = yup.object().shape({
    corpClientApplicationAccountOperationAuthSignId: yup.number()
        .nullable(),

    fullName: yup
        .string()
        .nullable()
        .matches(alphabet_dash_regix, "characters_should_be_alphabets"),

    identificationNo: yup
        .string()
        .nullable(),

    jobTitle: yup
        .string().
        nullable(),

    nationalityId: yup
        .number()
        .nullable(),

    sequenceId: yup
        .number()
        .nullable(),

    signatureDocument: yup
        .mixed()
        .nullable()
});


export const account_operation_validation_schema = yup.object().shape({
    accountManagement: yup.number().nullable(),
    accountManagementOther: yup.string()
        .when("accountManagement", {
            is: 1091,
            then: (schema) => schema,
            otherwise: (schema) => schema.nullable(),
        }),
    accountOperationAuthSigns: yup.array()
        // .min(1, "atleast_signatory_required")
        .of(
        signatory_add_validation_schema
    ),
    // corpClientApplicationAccountOperationId: yup.number().nullable(),
    ClientApplicationId: yup.number().nullable(),
    // modifiedBy: yup.number(),
    // modifiedDate: yup.string(),
    // signatureSpecimenDocument: yup.object().nullable(),

})

